import { render } from "./contactSection.vue?vue&type=template&id=1bfcb37b"
import script from "./contactSection.vue?vue&type=script&lang=js"
export * from "./contactSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__